<div id="{{mapId}}" class="map-container"></div>

